module.exports = __webpack_public_path__ + "img/IMG_2368_FoamcoreMatted.80c8c023.jpg";